<div class="collapsed">
  <form
    action=""
    autocomplete="off"
    class="edit-padding-10-20px credit-search-form"
    [formGroup]="searchCreditByIdForm"
    (ngSubmit)="findCreditById($event)"
  >
    <div flex layout="row" layout-align="space-between center">
      <mat-form-field subscriptSizing="dynamic" flex>
        <input
          #creditIdInput
          cdkFocusInitial
          matInput
          type="number"
          formControlName="creditId"
          placeholder="{{ 'global.credit' | translate }}"
        />
        <mat-label>{{ 'global.credit' | translate }}</mat-label>
      </mat-form-field>
      <button
        mat-raised-button
        type="submit"
        tabIndex="-1"
        matTooltip="{{ 'global.loadCredit' | translate }}"
        layout-align="end end"
      >
        <mat-icon>arrow_forward</mat-icon>
      </button>
    </div>
  </form>
  <mat-divider></mat-divider>
  <form
    autocomplete="off"
    class="edit-padding-20px row-gap-10"
    [formGroup]="searchCreditForm"
    (ngSubmit)="findCredit($event)"
  >
    <div flex layout="column" class="row-gap-10">
      <div flex layout="row">
        <mat-form-field subscriptSizing="dynamic" flex="50">
          <input
            matInput
            type="text"
            (paste)="trimValue($event, 'civilId')"
            formControlName="civilId"
            placeholder="{{ 'global.civilId' | translate }}"
          />
          <mat-label>{{ 'global.civilId' | translate }}</mat-label>
          <itfg-form-control-clear
            matSuffix
            [control]="searchCreditForm.get('civilId')"
          ></itfg-form-control-clear>
          @if (
            searchCreditForm.get('civilId').hasError('minlength') &&
            !searchCreditForm.get('civilId').hasError('onlyNumbers')
          ) {
            <mat-error
              [translateParams]="{ value: 6 }"
              [translate]="'forms.minLength'"
              >Min value error
            </mat-error>
          }
          @if (
            searchCreditForm.get('civilId').hasError('maxlength') &&
            !searchCreditForm.get('civilId').hasError('onlyNumbers')
          ) {
            <mat-error
              [translateParams]="{ value: 10 }"
              [translate]="'forms.maxLength'"
              >Max value error
            </mat-error>
          }
          @if (searchCreditForm.get('civilId').hasError('onlyNumbers')) {
            <mat-error [translate]="'forms.valueNotValid'"
              >Invalid value
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field subscriptSizing="dynamic" flex="50">
          <input
            matInput
            type="text"
            (paste)="trimValue($event, 'phone')"
            formControlName="phone"
            placeholder="{{ 'global.phone' | translate }}"
          />
          <mat-label>{{ 'global.phone' | translate }}</mat-label>
          <itfg-form-control-clear
            matSuffix
            [control]="searchCreditForm.get('phone')"
          ></itfg-form-control-clear>
          @if (searchCreditForm.get('phone').hasError('minlength')) {
            <mat-error
              [translateParams]="{ value: 5 }"
              [translate]="'forms.minLength'"
              >Min value error
            </mat-error>
          }
          @if (searchCreditForm.get('phone').hasError('maxlength')) {
            <mat-error
              [translateParams]="{ value: 15 }"
              [translate]="'forms.maxLength'"
              >Max value error
            </mat-error>
          }
        </mat-form-field>
      </div>
      <div flex layout="row">
        <mat-form-field subscriptSizing="dynamic" flex>
          <input
            matInput
            type="text"
            (paste)="trimValue($event, 'email')"
            formControlName="email"
            placeholder="{{ 'global.emailContains' | translate }}"
          />
          <mat-label>{{ 'global.emailContains' | translate }}</mat-label>
          <itfg-form-control-clear
            matSuffix
            [control]="searchCreditForm.get('email')"
          ></itfg-form-control-clear>
          @if (searchCreditForm.get('email').hasError('minlength')) {
            <mat-error
              [translateParams]="{ value: 3 }"
              [translate]="'forms.minLength'"
              >Min value error
            </mat-error>
          }
          @if (searchCreditForm.get('email').hasError('maxlength')) {
            <mat-error
              [translateParams]="{ value: 50 }"
              [translate]="'forms.maxLength'"
              >Max value error
            </mat-error>
          }
        </mat-form-field>
      </div>
      <div flex layout="row">
        <mat-form-field subscriptSizing="dynamic" flex="50">
          <input
            matInput
            type="text"
            formControlName="firstName"
            placeholder="{{ 'users.firstName' | translate }}"
            (paste)="transformFirstNameValue($event)"
          />
          <mat-label>{{ 'users.firstName' | translate }}</mat-label>
          <itfg-form-control-clear
            matSuffix
            [control]="searchCreditForm.get('firstName')"
          ></itfg-form-control-clear>
          @if (searchCreditForm.get('firstName').hasError('minlength')) {
            <mat-error
              [translateParams]="{ value: 2 }"
              [translate]="'forms.minLength'"
              >Min value error
            </mat-error>
          }
          @if (searchCreditForm.get('firstName').hasError('maxlength')) {
            <mat-error
              [translateParams]="{ value: 30 }"
              [translate]="'forms.maxLength'"
              >Max value error
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field subscriptSizing="dynamic" flex="50">
          <input
            matInput
            type="text"
            formControlName="middleName"
            placeholder="{{ 'users.middleName' | translate }}"
            (paste)="transformMiddleNameValue($event)"
          />
          <mat-label>{{ 'users.middleName' | translate }}</mat-label>
          <itfg-form-control-clear
            matSuffix
            [control]="searchCreditForm.get('middleName')"
          ></itfg-form-control-clear>
          @if (searchCreditForm.get('middleName').hasError('minlength')) {
            <mat-error
              [translateParams]="{ value: 2 }"
              [translate]="'forms.minLength'"
              >Min value error
            </mat-error>
          }
          @if (searchCreditForm.get('middleName').hasError('maxlength')) {
            <mat-error
              [translateParams]="{ value: 30 }"
              [translate]="'forms.maxLength'"
              >Max value error
            </mat-error>
          }
        </mat-form-field>
      </div>
      <div flex layout="row">
        <mat-form-field subscriptSizing="dynamic" flex>
          <input
            matInput
            type="text"
            (paste)="trimValue($event, 'lastName')"
            formControlName="lastName"
            placeholder="{{ 'users.lastName' | translate }}"
          />
          <mat-label>{{ 'users.lastName' | translate }}</mat-label>
          <itfg-form-control-clear
            matSuffix
            [control]="searchCreditForm.get('lastName')"
          ></itfg-form-control-clear>
          @if (searchCreditForm.get('lastName').hasError('minlength')) {
            <mat-error
              [translateParams]="{ value: 2 }"
              [translate]="'forms.minLength'"
              >Min value error
            </mat-error>
          }
          @if (searchCreditForm.get('lastName').hasError('maxlength')) {
            <mat-error
              [translateParams]="{ value: 30 }"
              [translate]="'forms.maxLength'"
              >Max value error
            </mat-error>
          }
        </mat-form-field>
      </div>
      <div flex="50" layout="row" layout-align="space-between center">
        <button
          mat-stroked-button
          flex
          [ngStyle]="{ 'margin-right': '5px' }"
          type="reset"
          color="accent"
          matTooltip="{{ 'global.clear' | translate }}"
          (click)="resetCreditList()"
          layout-align="end end"
        >
          <mat-icon>clear</mat-icon>
        </button>
        <button
          mat-stroked-button
          flex
          tabIndex="-1"
          matTooltip="{{ 'global.search' | translate }}"
          color="primary"
          layout-align="end end"
        >
          <mat-icon>search</mat-icon>
        </button>
      </div>
    </div>
  </form>
  <mat-nav-list>
    @for (creditSearchView of creditList; track creditSearchView) {
      <ng-container flex>
        <a
          routerLink="/credits/{{ creditSearchView.id }}"
          mat-list-item
          class="list-item-height"
          (click)="closeSideDrawerMenu()"
        >
          <span class="search-result">
            <div class="font-size-15 search-result-title">
              <itfg-credit-status-icon
                class="status-icon-compact"
                [creditStatus]="{ name: creditSearchView.creditStatusName }"
              ></itfg-credit-status-icon>
              <span
                class="search-result-product"
                [matTooltip]="creditSearchView.userBrandName"
                matTooltipPosition="right"
              >
                {{ creditSearchView.productName }} / {{ creditSearchView.id }}
              </span>
            </div>
            <div class="font-size-14 color-gray">
              <span>{{ creditSearchView.userFullName }}</span>
              @if (creditSearchView.userCivilId) {
                <span> / {{ creditSearchView.userCivilId }}</span>
              }
            </div>
            <div class="font-size-14 color-gray">
              @if (creditSearchView.userEmail) {
                <span>{{ creditSearchView.userEmail }}</span>
              }
              @if (creditSearchView.userMobile) {
                <span> / {{ creditSearchView.userMobile }}</span>
              }
            </div>
          </span>
        </a>
      </ng-container>
    }
    @if (!isData) {
      <div
        class="edit-padding-20px"
        flex
        [translate]="'credits.noResultsFound'"
      >
        No results found
      </div>
    }
  </mat-nav-list>
</div>
